import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { Grid } from '../../components';
import {
    eventoService,
    Utils,
    subeventoService,
    areaService,
    projetosNotaFinalService,
} from '../../services';
import PrincipalMaster from '../master/Principal';
import PublicMaster from '../master/Public';

class ProjetosAprovados extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tituloEvento: '',
            dsSubeventos: [],
            dsAreas: [],
            eventoSelecionado: 0,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
            dsProjetos: [],
        };
    }

    async componentWillMount() {
        const evento = await Utils.getBase64Decode(this.props.match.params.evento);
        await this.buscarSubEventosPeloEvento(evento);
    }
    async getProjetosAprovados(evento, subevento, area) {
        const projetos = await projetosNotaFinalService.getProjetosAprovados(evento, subevento, area);
        this.setState({ dsProjetos: projetos });
    }

    async buscarSubEventosPeloEvento(evento) {
        const dadosSubevento = await subeventoService.getSubeventosDoEvento(evento);
        const nome = await eventoService.getEvento(evento);
        this.setState({
            tituloEvento: nome.NOME,
            eventoSelecionado: evento,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
            dsSubeventos: dadosSubevento,
        });
        this.getProjetosAprovados(evento, 0, 0);
    }

    async buscarAreasPeloSubEvento(subevento) {
        const { eventoSelecionado } = this.state;
        const areas = await areaService.getAreas(subevento);
        this.setState({ dsAreas: areas, subeventoSelecionado: subevento });
        this.getProjetosAprovados(eventoSelecionado, subevento, 0);
    }

    async buscarAreas(area) {
        const { eventoSelecionado, subeventoSelecionado } = this.state;

        this.setState({ areaSelecionada: area });
        this.getProjetosAprovados(eventoSelecionado, subeventoSelecionado, area);
    }

    render() {
        const {
            tituloEvento,
            dsSubeventos,
            areaSelecionada,
            subeventoSelecionado,
            dsAreas,
            dsProjetos,
        } = this.state;

        const MasterPage = Utils.getUsuarioEstaLogado() ? PrincipalMaster : PublicMaster;

        return (
            <MasterPage title="Resumos/Projetos Aprovados">
                <div>
                    <h2>{tituloEvento}</h2>
                    <h3>Filtrar por: </h3>
                    <SelectField
                        floatingLabelText="Selecionar um subevento"
                        value={subeventoSelecionado}
                        onChange={(_event, _index, value) => this.buscarAreasPeloSubEvento(value)}
                        errorText={subeventoSelecionado > 0 ? '' : 'Campo obrigatório'}
                        fullWidth
                    >
                        <MenuItem value={0} />
                        {
                            dsSubeventos.map(subevento => (
                                <MenuItem key={subevento.CODIGO} value={subevento.CODIGO} primaryText={subevento.NOME} />
                            ))
                        }
                    </SelectField>

                    <SelectField
                        floatingLabelText="Selecionar uma área"
                        value={areaSelecionada}
                        onChange={(_event, _index, value) => this.buscarAreas(value)}
                        errorText={areaSelecionada > 0 ? '' : 'Campo obrigatório'}
                        fullWidth
                    >
                        <MenuItem value={0} />
                        {
                            dsAreas.map(area => (
                                <MenuItem key={area.CODIGO} value={area.CODIGO} primaryText={area.NOME} />
                            ))
                        }
                    </SelectField>
                </div>
                

                <div>
                    <div className="padding-content">
                        <Grid
                            ref={(ref) => { this.projetosGridRef = ref; }}
                            stripedRows="true"
                            textTableEmpty="Nenhum título encontrado"
                            dataSource={dsProjetos}
                            columnSortDefault={0}
                            rowsPerPage="10000"
                            columns={[
                                {
                                    text: 'Título', name: 'TITULO', allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: 500,
                                },
                                {
                                    text: 'Modalidade', name: 'MODALIDADE', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Local', name: 'SALA', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Data Apresentação', name: item => Utils.getFormatDate(item.DATAAPRESENTACAO), allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Início', name: item => Utils.getFormatHora(item.HORAINICIO), allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Fim', name: item => Utils.getFormatHora(item.HORAFIM), allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                            ]}
                        />
                    </div>

                </div>
            </MasterPage>
        );
    }
}
export default ProjetosAprovados;
